const INITIAL_STATE = 'INITIAL_STATE'
const SET_AUTHORIZATION = 'SET_AUTHORIZATION'
const SET_USERINFO = 'SET_USERINFO'
const SET_FILESERVER = 'SET_FILESERVER'
const SET_PICSERVER = 'SET_PICSERVER'
const CHANGE_MAP = 'CHANGE_MAP'
const SET_USERAVATAR = 'SET_USERAVATAR'
const CHANGE_PLATFORM = 'CHANGE_PLATFORM'
export { INITIAL_STATE, SET_AUTHORIZATION, 
	CHANGE_PLATFORM,SET_USERINFO, SET_FILESERVER,SET_PICSERVER,CHANGE_MAP,SET_USERAVATAR }
